import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const EyeIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.55302 12.6275C4.12034 8.97465 7.85696 6.51416 12 6.51416C16.143 6.51416 19.8797 8.97465 21.447 12.6275L21.4559 12.6483L21.447 12.6692C19.8797 16.322 16.143 18.7825 12 18.7825C7.85696 18.7825 4.12034 16.322 2.55302 12.6692L2.54408 12.6483L2.55302 12.6275Z"
        stroke={color}
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M14.1313 12.6457C14.1313 13.823 13.177 14.7773 11.9997 14.7773C10.8225 14.7773 9.86816 13.823 9.86816 12.6457C9.86816 11.4685 10.8225 10.5142 11.9997 10.5142C13.177 10.5142 14.1313 11.4685 14.1313 12.6457Z"
        stroke={color}
      />
    </svg>
  );
};

export default EyeIcon;
